var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("detalhe-oferta", { attrs: { oferta: _vm.oferta } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }